import React, { useEffect, useState, Fragment } from 'react';
import { AlarmClockIcon, FlameIcon, UsersIcon } from 'lucide-react';
import { useSharedCountdown } from './CountdownTimer';
export function UrgencyModule() {
  const secondsLeft = useSharedCountdown();
  const TOTAL_SPOTS = 10;
  const [spotsLeft, setSpotsLeft] = useState(7);
  useEffect(() => {
    const spotsTimer = setInterval(() => {
      setSpotsLeft(prev => {
        if (prev <= 2) return prev;
        return Math.random() < 0.15 ? prev - 1 : prev;
      });
    }, 15000);
    return () => clearInterval(spotsTimer);
  }, []);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const hours = 0;
  const percentLeft = spotsLeft / TOTAL_SPOTS * 100;
  return <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-red-900 via-red-950 to-black py-12 px-4 border-y-4 border-red-600 relative overflow-hidden shadow-[0_0_50px_rgba(220,38,38,0.3)] pt-[35px] pb-[35px]" data-id="element-396">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-full bg-red-600/20 rounded-full blur-3xl pointer-events-none" data-id="element-397"></div>
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-398">
        {/* Top alert badge */}
        <div className="flex justify-center mb-6" data-id="element-399">
          <div className="inline-flex items-center gap-2 bg-red-600 text-white font-black text-xs md:text-sm px-6 py-2.5 rounded-full uppercase tracking-widest shadow-[0_0_20px_rgba(220,38,38,0.5)] animate-bounce" data-id="element-400">
            <FlameIcon className="h-5 w-5 fill-white" data-id="element-401" />
            ¡ATENCIÓN! ÚLTIMOS CUPOS DISPONIBLES
          </div>
        </div>

        {/* Main headline */}
        <h2 className="text-4xl md:text-6xl font-black text-center mb-4 uppercase leading-tight" data-id="element-402">
          <span className="text-white" data-id="element-403">LA OFERTA ESTÁ</span>{' '}
          <span className="text-red-500 drop-shadow-[0_0_15px_rgba(239,68,68,0.8)]" data-id="element-404">
            POR FINALIZAR
          </span>
          <br data-id="element-405" />
          <span className="text-white text-2xl md:text-4xl font-bold italic" data-id="element-406">
            ¡No te quedes afuera!
          </span>
        </h2>

        <p className="text-center text-red-100 text-base md:text-lg mb-10 font-medium max-w-2xl mx-auto" data-id="element-407">
          Esta promoción es exclusiva y los cupos se están agotando en este
          mismo momento. Cuando el reloj llegue a cero, el precio subirá
          automáticamente.
        </p>

        <div className="grid md:grid-cols-2 gap-8 mb-4" data-id="element-408">
          {/* Countdown Card */}
          <div className="bg-black/60 backdrop-blur-md rounded-3xl p-8 border-2 border-red-600 shadow-[0_0_30px_rgba(220,38,38,0.2)]" data-id="element-409">
            <div className="flex items-center justify-center gap-2 mb-6" data-id="element-410">
              <AlarmClockIcon className="h-6 w-6 text-red-500" data-id="element-411" />
              <p className="text-red-500 font-black text-base uppercase tracking-widest" data-id="element-412">
                TIEMPO RESTANTE
              </p>
            </div>
            <div className="flex justify-center gap-3 md:gap-4" data-id="element-413">
              {[{
              value: hours,
              label: 'Horas'
            }, {
              value: minutes,
              label: 'Minutos'
            }, {
              value: seconds,
              label: 'Segundos'
            }].map((unit, i) => <Fragment key={unit.label} data-id="element-414">
                  <div className="flex flex-col items-center" data-id="element-415">
                    <div className="bg-red-950/50 border-2 border-red-600 rounded-xl px-4 md:px-6 py-3 md:py-4 shadow-[0_0_20px_rgba(220,38,38,0.3)] min-w-[70px] md:min-w-[90px]" data-id="element-416">
                      <span className="text-4xl md:text-6xl font-black text-white tabular-nums tracking-tighter drop-shadow-[0_0_10px_rgba(255,255,255,0.4)]" data-id="element-417">
                        {String(unit.value).padStart(2, '0')}
                      </span>
                    </div>
                    <span className="text-[11px] md:text-xs text-red-200 mt-3 uppercase tracking-widest font-black" data-id="element-418">
                      {unit.label}
                    </span>
                  </div>
                  {i < 2 && <span className="text-4xl md:text-6xl font-black text-red-600 self-start mt-2 md:mt-3" data-id="element-419">
                      :
                    </span>}
                </Fragment>)}
            </div>
          </div>

          {/* Spots Card */}
          <div className="bg-black/60 backdrop-blur-md rounded-3xl p-8 border-2 border-red-600 shadow-[0_0_30px_rgba(220,38,38,0.2)]" data-id="element-420">
            <div className="flex items-center justify-center gap-2 mb-6" data-id="element-421">
              <UsersIcon className="h-6 w-6 text-red-500" data-id="element-422" />
              <p className="text-red-500 font-black text-base uppercase tracking-widest" data-id="element-423">
                LUGARES DISPONIBLES
              </p>
            </div>
            <div className="text-center mb-5" data-id="element-424">
              <span className="text-6xl md:text-8xl font-black text-white tabular-nums drop-shadow-[0_0_15px_rgba(255,255,255,0.3)]" data-id="element-425">
                {spotsLeft}
              </span>
              <span className="text-3xl md:text-4xl font-bold text-red-500/50" data-id="element-426">
                {' '}
                / {TOTAL_SPOTS}
              </span>
            </div>
            {/* Progress bar */}
            <div className="relative w-full h-5 bg-red-950/50 rounded-full overflow-hidden border-2 border-red-900" data-id="element-427">
              <div className="absolute inset-y-0 left-0 bg-gradient-to-r from-red-800 via-red-500 to-red-400 rounded-full transition-all duration-1000 ease-out shadow-[0_0_20px_rgba(239,68,68,0.8)]" style={{
              width: `${percentLeft}%`
            }} data-id="element-428" />
            </div>
            <p className="text-center text-sm text-white mt-4 font-black uppercase tracking-tighter animate-pulse" data-id="element-429">
              <span className="inline-block neon-emoji-red" data-id="element-430">⚠️</span> ¡QUEDAN
              MENOS DE 10 CUPOS! ASEGURÁ EL TUYO
            </p>
          </div>
        </div>

        {/* Bottom warning */}
        <div className="text-center mt-8" data-id="element-431">
          <div className="inline-block bg-red-600/20 border border-red-600 px-6 py-3 rounded-2xl" data-id="element-432">
            <p className="text-white text-sm md:text-lg font-bold" data-id="element-433">
              <span className="inline-block neon-emoji-red" data-id="element-434">🔒</span> Una vez
              que el contador llegue a 00:00,{' '}
              <span className="text-red-500 font-black underline" data-id="element-435">
                esta oferta desaparece para siempre
              </span>{' '}
              y el precio sube a{' '}
              <span className="line-through text-red-400" data-id="element-436">$59.990</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}